import { useI18n } from 'vue-i18n';

export function useLocale() {
    const { t, locale} = useI18n();
    const localeOptions = [
        { label: 'English', value: 'en' },
        { label: 'Deutsch', value: 'de' }
    ]

    const getFlagClass = (l) => {
        switch (l) {
            case "en":
                return 'fi fi-gb';
            default:
                return `fi fi-${l}`
        }
    }

    return {
        locale,
        localeOptions,
        getFlagClass
    }
}
